<template>
  <div class="cust-card mx-auto">
    <div class="logo mb-4">
      <img src="https://static.tactint.com/ID-logoText.svg" />
    </div>
    <b-card class="mb-2">
      <div v-if="image">
        <img :src="image" alt width="150px" class="flex-horizontal-center rounded-circle mt-5 mb-4 mx-auto" />
      </div>
      <div class="title" v-if="title">{{title}}</div>

      <div class="action" v-if="$slots['actions']">
        <slot name="actions"></slot>
      </div>

      <div class="body" v-if="$slots.default">
        <slot></slot>
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  props: {
    image: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped>
.logo {
  text-align: center;
  flex-direction: row;
  img {
    height: 30px;
  }
}
.cust-card {
  height: 100vh;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  //background: linear-gradient(to bottom right, #d7bbea, #65a8f1);
  #logo {
    margin: 12% 0;
    text-align: center;
  }
  .title {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    padding-bottom: 1rem;
    margin-top: 1rem;
    margin-bottom: 2rem;
    position: relative;
    z-index: 1;
    padding-left: 60px;
    font-size: 24px;
    font-weight: 500;
    &::after {
      content: "";
      background-color: #3c3a3a;
      width: 32px;
      height: 7px;
      border-radius: 2px;
      display: block;
      position: absolute;
      bottom: -4px;
      left: 60px;
    }
  }
  div.card {
    width: 30rem;
    max-width: 96%;
    .card-body {
      padding: 0;
    }
    .action {
      padding: 20px;
      display: flex;
      flex-direction: column;
    }
    .flex-horizontal-center {
      display: flex;
      justify-content: center;
    }
    .body {
      padding: 30px;
    }
  }
}
</style>
